import { action } from 'satcheljs';
export var toggleAllowAccess = action('adsPrefsOption_toggleAllowAcess');
export var toggleAllowPersonalization = action('adsPrefsOption_toggleAllowPersonalization');
export var toggleAllowAdSelection = action('adsPrefsOption_toggleAllowAdSelection');
export var toggleAllowContentSelection = action('adsPrefsOption_toggleAllowContentSelection');
export var toggleAllowMeasurement = action('adsPrefsOption_toggleAllowMeasurement');
export var setOptions = action('adsPerfsOption_setOptions', function (options) { return ({ options: options }); });
//# sourceMappingURL=advertisingOptionsActions.js.map